import { STATUS_KLEUREN, type KaartStatus } from '@/types/domain';

/**
 * De rand rond een stip.
 *
 * Wit maakt elke kleur los van de luchtfoto — behalve de witte stip zelf,
 * die anders in het niets zou oplossen. Die krijgt de donkerblauwe rand.
 */
function randkleur(status: KaartStatus): string {
  return status === 'Nog niet bezocht' ? '#1c2445' : '#ffffff';
}

interface StatusStipProps {
  status: KaartStatus;
  /** Doorsnede in pixels. */
  formaat?: number;
  label?: string;
}

/**
 * De statusstip: één rondje, in de kleur van de status.
 *
 * Allemaal dezelfde vorm, met opzet. Zes verschillende silhouetten maakten de
 * kaart onrustig; met rondjes leest een straat als één reeks in plaats van als
 * een verzameling losse tekens.
 *
 * Daarmee draagt kleur de betekenis alleen, en dat stelt eisen: de zes zijn
 * doorgerekend op onderlinge afstand, ook zoals iemand met kleurenblindheid ze
 * ziet. Zie de toelichting bij STATUS_KLEUREN.
 */
export function StatusStip({ status, formaat = 14, label }: StatusStipProps): JSX.Element {
  return (
    <span
      className="statusstip"
      role={label ? 'img' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
      style={{
        width: formaat,
        height: formaat,
        background: STATUS_KLEUREN[status],
        borderColor: randkleur(status),
      }}
    />
  );
}
